import { FormContent, FormHeader } from '@factorialco/f0-react'
import type { FormCanvasContent } from '@factorialco/f0-react'

import { defineCanvasEntity } from 'modules/ai/copilotActions/canvas/defineCanvasEntity'

/**
 * Canvas renderer for `{ type: "form" }` content. The active form is read
 * from f0's `F0AiFormRegistry`, so no wrapper is needed.
 */
export const formCanvasEntity = defineCanvasEntity<FormCanvasContent>({
  type: 'form',
  overflowHidden: true,
  renderContent: () => <FormContent />,
  renderHeader: ({ content, onClose }) => (
    <FormHeader
      title={content.title}
      description={content.description}
      module={content.formModule}
      onClose={onClose}
    />
  ),
})
